var modCookies = function(){
    var scope = ".js-mod-cookies";
    ui.ready(
        scope,
        function($mod){
            var cookieN = "cookiesok";
            var cookieV = "ok";
            var cookie = cookies.read(cookieN);
            var $cookies = $("#cookiemod");
            if(cookie!=cookieV){
                $cookies.css("display","block");
            }
            $cookies.toggle(cookie!=cookieV);
            $mod.find(scope+"__accept-all").click(
                function(ev){
                    ev.preventDefault();
                    cookies.create(cookieN,cookieV,365);
                    $cookies.css("display","none");

                }
            );

            $mod.find(scope+"__configure").click(
                function(ev){
                    ev.preventDefault();
                    $cookies.find(scope+"__config").toggle();
                }
            );

            $mod.find(scope+"__confirm-config").click(
                function(ev){
                    ev.preventDefault();
                    cookies.create(cookieN,cookieV,365);
                    $cookies.css("display","none");
                }
            );
        }

    );
}();